import { UpdateMetricsDataAction, MetricsDataActionTypes } from './ActionTypes';

export function updateMetricsData(ids: string[]): UpdateMetricsDataAction {
  return {
    type: MetricsDataActionTypes.UPDATE_DATA,
    metrics: ids,
  };
}
